<script lang="ts">
import { defineBlock } from '@bagelink/blox'
export const TopNav = defineBlock({ name: 'TopNav', label: 'Top Navigation', icon: 'menu', order: 1, global: true })
</script>
<script lang="ts" setup>

import { Btn, Icon } from '@bagelink/vue'
import { onUnmounted, ref } from 'vue'


const scrolledMenu = ref(false)
const openMobileMenu = ref(false)

function onScroll() {
	scrolledMenu.value = window.scrollY > 200
}
if (typeof window !== 'undefined') {
	window.addEventListener('scroll', onScroll)
	onUnmounted(() => window.removeEventListener('scroll', onScroll))
}
</script>

<template>
	<div class="txt-center z-9 pb-2 pt-05 px-1  m_p-1 m_bg-white transition m_sticky menuBefore" :class="{ scrolledMenu }">
		<div class="w1050px">
			<router-link to="/" class=" w-fit menuLogo">
				<img src="@/assets/ati-logo.svg" alt="Academic Torah Institute" class="h40px">
			</router-link>
			<Btn class="none m_block absolute top-1 end-1 pt-05" round flat thin @click="openMobileMenu = true">
				<Icon name="menu" size="1.2" />
			</Btn>
			<div
				class="mobileMenu mx-auto m_bg-black m_fixed m_z-99 m_inset m_column transition flex justify-content-center m_w100vw m_justify-content-start m_flex-stretch"
				:class="{ openMobileMenu }"
			>
				<div class="flex justify-content-end py-1 px-05 none m_block txt-start">
					<Btn flat thin round class="m_color-white" @click="openMobileMenu = false">
						<Icon name="close" size="1.6" />
					</Btn>
				</div>
				<div class="flex m_column gap-3 m_gap-075">
					<Btn to="/#publications" flat class=" px-05  m_color-white m_mx-2 " value="Publications" @click="openMobileMenu = false" />
					<Btn to="/#impact" flat class=" px-05  m_color-white m_mx-2 " value="Impact" @click="openMobileMenu = false" />
					<Btn to="/#staff" flat class=" px-05  m_color-white m_mx-2 " value="Staff" @click="openMobileMenu = false" />
					<Btn to="/#recognition" flat class=" px-05  m_color-white m_mx-2 " value="Recognition" @click="openMobileMenu = false" />
					<Btn to="/#partner" flat class="color-red m_color-white px-05 m_mx-2 " value="Partner" @click="openMobileMenu = false" />
				</div>
			</div>
		</div>
	</div>
</template>

<style scoped>
.scrolledMenu{
	background: var(--bgl-white);
	position: sticky;
	border-bottom: 1px solid var(--bgl-gray);
	padding: 0 1rem !important;
	animation: startmenu 0.3s ease-in-out;
	top: 0%;
}
.scrolledMenu>div{
	display: flex;
	justify-content: space-between;
}

@keyframes startmenu {
	0% {
		transform: translateY(-100%);
	}
	100% {
		transform: translateY(0);
	}
}
.scrolledMenu .mobileMenu{
	margin-inline-end: 0 !important;
}
.menuLogo{
	display: none;
}
.scrolledMenu .menuLogo{
	padding: 1rem !important;
	display: block;
}

@media screen and (max-width: 910px) {
.mobileMenu{
	transform: translateX(105%);
	transition: var(--bgl-transition);

}
.openMobileMenu{
	transform: translateX(0%);
	transition: var(--bgl-transition);
}
.scrolledMenu{
	border-bottom: 1px solid var(--bgl-gray);
}
.menuBefore{
	background: var(--bgl-white);
	position: sticky;
	display: flex;
	justify-content: space-between;
	animation: startmenu 0.3s ease-in-out;
	top: 0%;
}
@keyframes startmenu {
	0% {
		transform: translateY(0%);
	}
	100% {
		transform: translateY(0);
	}
}

.menuLogo{
	display: block;
	opacity: 0;
}
.scrolledMenu .menuLogo{
	opacity: 1;
}}
</style>
